import { AxiosInstance } from 'axios';
import { useMutation } from 'react-query';
import { snackbarService } from 'src/components/common/snackbar/snackbar-service';

import { apiUrlV4 } from '../constants/api-versions';
import { ApiResponse } from './types';

export const OverlayBuilderService = (axios: AxiosInstance) => {
  const UploadLogo = () => {
    const uploadLogo = async ({ logo, name }: { logo: string, name: string }) => {
      const res = await axios.post<ApiResponse<{ url: string }>>(`${apiUrlV4}overlay-builder/logo/upload`, {
        logo_data_url: logo,
        school_name: name,
      });
      return res.data.data.url;
    };

    return useMutation(uploadLogo, {
      onError: (error) => {
        snackbarService.error("Can't upload logo. Please, try later.");
        console.error('Error in uploading logo:', error);
      },
    });
  };

  return {
    UploadLogo
  };
};
